(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chronos-review-request"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-client-reviews]');
    const createElement = (tag, className, text) => {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text !== undefined) element.textContent = text;
      return element;
    };
    const renderStars = (rating, isSwedish) => {
      const stars = createElement('div', 'chronos-client-review-card__stars');
      stars.setAttribute('aria-label', isSwedish ? `${rating} av 5 stjärnor` : `${rating} out of 5 stars`);
      for (let index = 1; index <= 5; index += 1) {
        const star = createElement('span', index <= rating ? 'is-filled' : '', '★');
        star.setAttribute('aria-hidden', 'true');
        stars.append(star);
      }
      return stars;
    };
    const renderReview = (review, source, profileUrl, linkLabel, isSwedish, localeCode) => {
      const card = createElement('article', 'chronos-client-review-card');
      const topline = createElement('div', 'chronos-client-review-card__topline');
      const avatar = createElement('span', 'chronos-client-review-card__avatar', (review.author || 'C').slice(0, 1).toUpperCase());
      avatar.setAttribute('aria-hidden', 'true');
      const identity = createElement('div');
      identity.append(createElement('h3', '', review.author || (isSwedish ? 'Kund' : 'Client')));
      let reviewDate = review.date || '';
      const parsedDate = reviewDate ? new Date(reviewDate) : null;
      if (parsedDate && !Number.isNaN(parsedDate.getTime())) reviewDate = parsedDate.toLocaleDateString(localeCode, { year: 'numeric', month: 'long', day: 'numeric' });
      identity.append(createElement('p', '', reviewDate));
      const sourceMark = createElement('span', `chronos-client-review-card__source chronos-client-review-card__source--${source}`, source === 'google' ? 'G' : 'C24');
      sourceMark.setAttribute('aria-label', source === 'google' ? 'Google' : 'Chrono24');
      topline.append(avatar, identity, sourceMark);
      card.append(topline, renderStars(review.rating, isSwedish));
      card.append(createElement('blockquote', '', review.text));
      const link = createElement('a', '', linkLabel);
      link.href = review.url || profileUrl;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      card.append(link);
      return card;
    };
    const updateSource = (root, source, data, isSwedish, localeCode) => {
      if (!data) return;
      const ratingCard = root.querySelector(`[data-rating-source="${source}"]`);
      const grid = root.querySelector(`[data-reviews-grid="${source}"]`);
      if (ratingCard) {
        const score = Number(data.rating || 0);
        ratingCard.style.setProperty('--rating-percent', `${Math.max(0, Math.min(score * 20, 100))}%`);
        const scoreNode = ratingCard.querySelector('[data-rating-score]');
        const countNode = ratingCard.querySelector('[data-rating-count]');
        const starsNode = ratingCard.querySelector('[data-rating-stars]');
        if (scoreNode) scoreNode.textContent = score.toFixed(1);
        if (countNode) countNode.textContent = isSwedish
          ? `Baserat på ${Number(data.reviewCount || 0)} recensioner`
          : `Based on ${Number(data.reviewCount || 0)} reviews`;
        if (starsNode) starsNode.setAttribute('aria-label', isSwedish ? `${score.toFixed(1)} av 5 stjärnor` : `${score.toFixed(1)} out of 5 stars`);
      }
      if (grid && Array.isArray(data.reviews)) {
        const reviews = data.reviews.filter((review) => Number(review.rating) >= 4 && review.text).slice(0, 10);
        if (reviews.length) grid.replaceChildren(...reviews.map((review) => renderReview(review, source, data.profileUrl, root.dataset.reviewLinkLabel || (isSwedish ? 'Läs hela recensionen' : 'Read full review'), isSwedish, localeCode)));
      }
    };
    roots.forEach(async (root) => {
      const feedUrl = root.dataset.feedUrl;
      if (!feedUrl) return;
      const status = root.querySelector('[data-review-feed-status]');
      const isSwedish = root.dataset.isSwedish === 'true';
      const localeCode = isSwedish ? 'sv-SE' : (root.dataset.locale || document.documentElement.lang || 'en');
      try {
        const response = await fetch(feedUrl, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Review feed unavailable');
        const payload = await response.json();
        updateSource(root, 'google', payload.sources && payload.sources.google, isSwedish, localeCode);
        updateSource(root, 'chrono24', payload.sources && payload.sources.chrono24, isSwedish, localeCode);
        const note = root.querySelector('[data-review-feed-note]');
        if (note && payload.updatedAt) {
          const verifiedDate = new Date(payload.updatedAt).toLocaleDateString(localeCode);
          note.textContent = payload.fresh === false
            ? (isSwedish ? `Senast verifierade betyg och omdömen visas från ${verifiedDate}.` : `Showing the latest verified ratings and reviews from ${verifiedDate}.`)
            : (isSwedish ? `Betyg och omdömen uppdaterades automatiskt ${verifiedDate}.` : `Ratings and reviews refreshed automatically ${verifiedDate}.`);
        }
        if (status) status.textContent = payload.fresh === false
          ? (isSwedish ? 'De senast verifierade kundomdömena visas.' : 'Showing the latest verified client reviews.')
          : (isSwedish ? 'Kundomdömena har uppdaterats.' : 'Client reviews updated.');
      } catch (error) {
        if (status) status.textContent = isSwedish ? 'De senast sparade kundrecensionerna visas.' : 'Showing the most recently saved client reviews.';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
